var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyclaimsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4283_13987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 3.33366H11.6667V5.83366H8.33333V3.33366H1.66667C1.22464 3.33366 0.800716 3.50925 0.488155 3.82181C0.175595 4.13437 0 4.5583 0 5.00033L0 16.667C0 17.109 0.175595 17.5329 0.488155 17.8455C0.800716 18.1581 1.22464 18.3337 1.66667 18.3337H18.3333C18.7754 18.3337 19.1993 18.1581 19.5118 17.8455C19.8244 17.5329 20 17.109 20 16.667V5.00033C20 4.5583 19.8244 4.13437 19.5118 3.82181C19.1993 3.50925 18.7754 3.33366 18.3333 3.33366ZM6.66667 7.50033C7.10869 7.50033 7.53262 7.67592 7.84518 7.98848C8.15774 8.30104 8.33333 8.72497 8.33333 9.16699C8.33333 9.60902 8.15774 10.0329 7.84518 10.3455C7.53262 10.6581 7.10869 10.8337 6.66667 10.8337C6.22464 10.8337 5.80072 10.6581 5.48816 10.3455C5.17559 10.0329 5 9.60902 5 9.16699C5 8.72497 5.17559 8.30104 5.48816 7.98848C5.80072 7.67592 6.22464 7.50033 6.66667 7.50033ZM10 14.167H3.33333V13.3337C3.33333 12.2253 5.55833 11.667 6.66667 11.667C7.775 11.667 10 12.2253 10 13.3337V14.167ZM16.6667 15.0003H11.6667V13.3337H16.6667V15.0003ZM16.6667 11.667H11.6667V10.0003H16.6667V11.667ZM16.6667 8.33366H11.6667V6.66699H16.6667V8.33366ZM10.8333 5.00033H9.16667V1.66699H10.8333V5.00033Z",
    fill: "#C7222A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4283_13987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyclaimsIcon);
export default __webpack_public_path__ + "static/media/myclaims-icon.58e3339bff4333fb3ea677c5152f789c.svg";
export { ForwardRef as ReactComponent };